import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=bff76fcc"
import script from "@/components/data-table/DataTable.ts?vue&type=script&lang=ts&external"
export * from "@/components/data-table/DataTable.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/data-table/datatable.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports